import { colors } from '@cabonline/ui-shared';
import {
  ApartmentOutlined,
  LocalTaxiOutlined,
  NotificationsOutlined,
  PersonOutlineRounded,
  RouteOutlined,
} from '@mui/icons-material';
import { useLocale } from '@multiplatform-apps/service-trips';
import { FC, useMemo } from 'react';

import { paths } from '../../../constants';
import { ENABLE_ABSENCE_LIST, ENABLE_NOTIFICATIONS } from '../../../constants/feature-toggles';
import { useIndexPermissions, usePermissions } from '../../../hooks';
import { MenuLink } from './menu-link';

interface MenuAuthItemsProps {
  closeMenu: () => void;
}

export const MenuAuthItems: FC<MenuAuthItemsProps> = ({ closeMenu }) => {
  const { t } = useLocale();
  const { hasRootRoutePermission: hasPermission } = usePermissions();
  const indexPermissions = useIndexPermissions();

  const items = useMemo(
    () => [
      {
        show: hasPermission('tripsPage'),
        to: paths.trips.root,
        label: t('navBar.trips'),
        icon: <RouteOutlined htmlColor={colors.black} />,
        rotateIcon: true,
      },
      {
        show: hasPermission('passengersPage'),
        to: paths.passengers.root,
        label: t('navBar.passengers'),
        icon: <LocalTaxiOutlined htmlColor={colors.black} />,
      },
      {
        show: hasPermission('usersPage'),
        to: paths.users.root,
        label: t('navBar.users'),
        icon: <PersonOutlineRounded htmlColor={colors.black} />,
      },
      {
        show: hasPermission('institutionsPage'),
        to: paths.institutions.root,
        label: t('navBar.institutions'),
        icon: <ApartmentOutlined htmlColor={colors.black} />,
      },
      {
        show: ENABLE_NOTIFICATIONS,
        to: paths.notifications.root,
        label: t('navBar.notifications'),
        icon: <NotificationsOutlined htmlColor={colors.black} />,
      },
      {
        show: !!indexPermissions?.canSeeGeneralAbsenceMenuItem,
        to: paths.absence.root,
        label: t('absence.title'),
      },
      {
        show: ENABLE_ABSENCE_LIST && !!indexPermissions?.canSeeGeneralAbsenceMenuItem,
        to: paths.absence.list,
        label: t('absenceList.title'),
      },
    ],
    [hasPermission, indexPermissions?.canSeeGeneralAbsenceMenuItem, t],
  );

  return (
    <>
      {items.map(
        (item) =>
          item.show && (
            <MenuLink
              key={item.to}
              to={item.to}
              label={item.label}
              icon={item.icon}
              rotateIcon={item.rotateIcon}
              onClick={closeMenu}
            />
          ),
      )}
    </>
  );
};
